import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

import Terms from '../components/Terms';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';

import {
  NitroAddressAutoComplete,
  NitroHeading,
  NitroCheckbox,
  NitroDatePicker,
  NitroPanel,
  NitroTextField,
  NitroGrids,
  NitroGrid
} from 'nitro-components';

import styled from 'styled-components';

const Row = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

class DeliveryDetails extends Component {
  constructor(props, context) {
    super(props, context);

    const { deliveryDetails } = props;

    let {
      DeliveryAddress,
      DeliveryState,
      DeliveryPostalCode,
      DeliverySuburb,
      CustomerContactPhone,
      CustomerName,
      DeliveryDate,
      ManualAddress
    } = deliveryDetails;

    DeliveryDate = DeliveryDate || '';

    this.state = {
      manualAddress: ManualAddress || false,
      dropDownAddress: !ManualAddress ? DeliveryAddress : '',
      streetAddress: ManualAddress ? DeliveryAddress : '',
      deliveryState: DeliveryState || '',
      deliveryPostalCode: DeliveryPostalCode || '',
      deliverySuburb: DeliverySuburb || '',
      customerContactPhone: CustomerContactPhone || '',
      customerName: CustomerName || '',
      deliveryDate: DeliveryDate,
      errors: {}
    };

    this.getAutoCompleteAddress = this.getAutoCompleteAddress.bind(this);
    this.setDeliveryDetailsAddress = this.setDeliveryDetailsAddress.bind(this);

    this.setStreetAddress = this.setStreetAddress.bind(this);
    this.setDeliveryState = this.setDeliveryState.bind(this);
    this.setDeliveryPostalCode = this.setDeliveryPostalCode.bind(this);
    this.setDeliverySuburb = this.setDeliverySuburb.bind(this);

    this.setCustomerName = this.setCustomerName.bind(this);
    this.setCustomerContactPhone = this.setCustomerContactPhone.bind(this);
    this.setDeliveryDate = this.setDeliveryDate.bind(this);
    this.updateReduxStore = this.updateReduxStore.bind(this);

    this.isNumber = this.isNumber.bind(this);
  }

  nextHandler = () => {
    this.updateReduxStore();
    const { quoteId } = this.props;
    const { updateQuote } = this.props.actions;
    const { leaseDetails } = this.props;

    const {
      manualAddress,
      dropDownAddress,
      streetAddress,
      deliveryState,
      deliveryPostalCode,
      deliverySuburb,
      customerContactPhone,
      customerName,
      deliveryDate
    } = this.state;

    let deliveryAddress = manualAddress ? streetAddress : dropDownAddress;

    const { exteriorColour, selectColour, selectedExtras } = this.props;

    const questionAnswerSession_Id = this.props.vehicles.QuestionAnswers_Id;
    const variantId = this.props.selectedVehicle.VariantId;
    const employerCode = null;
    const term = this.props.selectedTerms ? this.props.selectedTerms.Term : null;
    const distance = this.props.selectedTerms ? this.props.selectedTerms.Distance : null;
    const exteriorColourCode = selectColour.Key;
   // const exteriorColourCode = exteriorColour && exteriorColour.filter(data => data.Value === selectColour)[0].Key;
    const interiorColourCode = null;
    const reliefVehicleCode = leaseDetails.ReliefVehicleCode ? leaseDetails.ReliefVehicleCode.key : null;
    const roadsideCode = leaseDetails.RoadsideCode ? leaseDetails.RoadsideCode.key : null;
    const maintenanceType = null;
    const fuelCardService = leaseDetails.FuelCardService ? leaseDetails.FuelCardService.key : null;
    const accidentManagementCode = leaseDetails.AccidentManagementCode ? leaseDetails.AccidentManagementCode.key : null;
    const insuranceCode = leaseDetails.InsuranceCode ? leaseDetails.InsuranceCode.key : null;
    const registrationState = leaseDetails.RegistrationState;
    const registrationPostalCode = leaseDetails.RegistrationPostalCode;
    const notes = null;
    const customerEmail = null;
    const tyresIncludedCode = leaseDetails.TyresIncludedCode ? leaseDetails.TyresIncludedCode.key : null;
    const tollServiceCode = leaseDetails.TollServiceCode ? leaseDetails.TollServiceCode.key : null;
    const vehicleOptions = selectedExtras.map(data => data.code);

    // const formattedDeliveryDate = moment(deliveryDate).format('YYYY-MM-DD');

    const payload = {
      QuoteId: quoteId,
      DeliveryState: deliveryState,
      DeliveryPostalCode: deliveryPostalCode,
      CustomerContactPhone: customerContactPhone,
      DeliveryAddress: deliveryAddress,
      DeliverySuburb: deliverySuburb,
      CustomerName: customerName,
      DeliveryDate: deliveryDate,
      QuestionAnswerSession_Id: questionAnswerSession_Id,
      VariantId: variantId,
      QuoteTemplateId: null,
      EmployerCode: employerCode,
      Term: term,
      Distance: distance,
      ExteriorColourCode: exteriorColourCode,
      InteriorColourCode: interiorColourCode,
      ReliefVehicleCode: reliefVehicleCode,
      RoadsideCode: roadsideCode,
      MaintenanceType: maintenanceType,
      FuelCardService: fuelCardService,
      AccidentManagementCode: accidentManagementCode,
      InsuranceCode: insuranceCode,
      RegistrationState: registrationState,
      RegistrationPostalCode: registrationPostalCode,
      Notes: notes,
      CustomerEmail: customerEmail,
      TyresIncludedCode: tyresIncludedCode,
      TollServiceCode: tollServiceCode,
      VehicleOptions: vehicleOptions
    };

    updateQuote(payload);

    // this.context.router.push(routes.CQ_CREATE_SUMMARY)
  };

  updateReduxStore() {
    const { setDeliveryDetails } = this.props.actions;
    const {
      dropDownAddress,
      streetAddress,
      deliveryState,
      deliveryPostalCode,
      deliverySuburb,
      customerContactPhone,
      customerName,
      deliveryDate,
      manualAddress
    } = this.state;

    const formattedDeliveryDate = moment(deliveryDate).format('YYYY-MM-DD');

    let deliveryAddress = streetAddress ? streetAddress : dropDownAddress;

    setDeliveryDetails(
      deliveryAddress,
      deliveryState,
      deliveryPostalCode,
      deliverySuburb,
      customerContactPhone,
      customerName,
      formattedDeliveryDate,
      manualAddress
    );
  }

  setCustomerName(e) {
    const fullName = e.target.value;

    this.setState({
      customerName: fullName
    });
  }

  setStreetAddress(e) {
    this.setState({ streetAddress: e.target.value });
  }

  setDeliveryState(event, index, value) {
    this.setState({ deliveryState: value });
  }

  setDeliveryPostalCode(e) {
    const postalCode = e.target.value;

    if (postalCode.length <= 4) {
      if (this.isNumber(postalCode)) this.setState({ deliveryPostalCode: postalCode });
      else if (postalCode === '') this.setState({ deliveryPostalCode: postalCode });
    }
  }

  setDeliverySuburb(e) {
    this.setState({ deliverySuburb: e.target.value });
  }

  isNumber(str) {
    let pattern = /^\d+$/;
    return pattern.test(str); // returns a boolean
  }

  setCustomerContactPhone(e) {
    const phone = e.target.value.replace(/\s/g, '');

    const validPhoneNumber = phone.length < 11 && this.isNumber(phone);

    if (validPhoneNumber || !phone) {
      this.setState({
        customerContactPhone: phone,
        customerContactPhoneError: null,
      });
    } else {
      this.setState({
        customerContactPhone: null,
        customerContactPhoneError: 'Please enter a valid contact number',
      });
    }
  }

  canSubmit(nextState) {
    const state = nextState || this.state;

    const {
      manualAddress,
      customerName,
      dropDownAddress,
      customerContactPhone,
      deliveryDate,
      streetAddress,
      deliveryState,
      deliveryPostalCode,
      deliverySuburb
    } = state;

    if (!manualAddress && customerName && dropDownAddress && customerContactPhone && deliveryDate) return true;
    else if (
      manualAddress &&
      streetAddress &&
      deliveryPostalCode &&
      deliveryState &&
      deliverySuburb &&
      customerName &&
      customerContactPhone &&
      deliveryDate
    ) {
      return true;
    }

    return false;
  }

  setDeliveryDate = date => {
    this.setState({ deliveryDate: date });
  };

  setDeliveryDetailsAddress(dropDownAddress, deliveryState, deliveryPostalCode, deliverySuburb, streetAddress) {
    this.setState({
      dropDownAddress: dropDownAddress,
      deliveryState: deliveryState,
      deliveryPostalCode: deliveryPostalCode,
      deliverySuburb: deliverySuburb,
      streetAddress: streetAddress,
    });

    // Update the manual address
    this.cachedManualAddress = {
      streetAddress: this.state.streetAddress,
      deliverySuburb: this.state.deliverySuburb,
      deliveryState: this.state.deliveryState,
      deliveryPostalCode: this.state.deliveryPostalCode
    };
  }

  showAddressDetails = (event, isInputChecked) => {
    // If switching from auto to manual (isInputChecked: true), use the saved manual address
    // If switching from manual to auto (isInputChecked: false), store the manual address
    this.cachedManualAddress = isInputChecked
      ? this.cachedManualAddress
      : {
          streetAddress: this.state.streetAddress,
          deliverySuburb: this.state.deliverySuburb,
          deliveryState: this.state.deliveryState,
          deliveryPostalCode: this.state.deliveryPostalCode
        };

    // Update the address state only if switching from auto to manual
    const applyCachedManualAddress = isInputChecked ? this.cachedManualAddress : {};

    this.setState({
      manualAddress: isInputChecked,
      ...applyCachedManualAddress
    });
  };

  getAutoCompleteAddress() {
    return (
      <NitroAddressAutoComplete
        value={this.state.dropDownAddress}
        setDeliveryDetailsAddress={this.setDeliveryDetailsAddress}
        disabled={this.state.manualAddress}
        fullWidth
      />
    );
  }

  getAddressDetails() {
    return (
      <div>
        <NitroTextField
          defaultValue={this.state.streetAddress}
          hintText="Enter street address"
          floatingLabelText="Street address"
          fullWidth
          onChange={this.setStreetAddress}
        />

        <NitroTextField
          defaultValue={this.state.deliverySuburb}
          hintText="Enter suburb"
          floatingLabelText="Suburb"
          style={{ marginRight: '30px', verticalAlign: 'bottom' }}
          onChange={this.setDeliverySuburb}
        />

        <SelectField
          value={this.state.deliveryState}
          floatingLabelText="State"
          style={{ marginRight: '30px', verticalAlign: 'bottom' }}
          onChange={this.setDeliveryState}>
          <MenuItem value={'NSW'} primaryText="New South Wales" />
          <MenuItem value={'NT'} primaryText="Northern Territory" />
          <MenuItem value={'QLD'} primaryText="Queensland" />
          <MenuItem value={'SA'} primaryText="South Australia" />
          <MenuItem value={'TAS'} primaryText="Tasmania" />
          <MenuItem value={'VIC'} primaryText="Victoria" />
          <MenuItem value={'WA'} primaryText="Western Australia" />
        </SelectField>

        <NitroTextField
          hintText="Enter country"
          floatingLabelText="Country"
          defaultValue="Australia"
          disabled
          style={{ marginRight: '30px' }}
        />

        <NitroTextField
          hintText="Postcode"
          floatingLabelText="Enter postcode"
          defaultValue={this.state.deliveryPostalCode}
          onChange={this.setDeliveryPostalCode}
        />
      </div>
    );
  }

  validateInput = (value, regex, errorText) => {
    if (!regex.test(value)) {
      return errorText;
    }

    return null;
  }

  render() {
    const { manualAddress } = this.state;

    //  if (manualAddress) this.setState({dropDownAddress: ''});

    const { deliveryDate } = this.state;

    const { selectedVehicle, estimatedCost, selectedTerms } = this.props;

    // const minDate = now.add(-1, 'day');

    return (
      <div>
        <NitroPanel>
          <NitroHeading label="Delivery address" size="2" align="left" noMargin />

          <Row>
            {this.getAutoCompleteAddress()}
          </Row>

          <Row>
            <NitroCheckbox
              label="Enter address manually"
              variant="secondary"
              action={this.showAddressDetails}
              checked={this.state.manualAddress}
            />
          </Row>

          {manualAddress ? this.getAddressDetails() : ''}
        </NitroPanel>

        <NitroPanel>
          <NitroHeading label="Contact details" size="2" align="left" noMargin />

          <NitroGrids>
            <NitroGrid grid={2}>
              <NitroTextField
                defaultValue={this.state.customerName}
                hintText="Enter your full name"
                floatingLabelText="Contact name"
                onChange={this.setCustomerName}
                fullWidth
              />
            </NitroGrid>

            <NitroGrid grid={2}>
              <NitroTextField
                defaultValue={this.state.customerContactPhone}
                hintText="Enter your contact number"
                floatingLabelText="Contact number"
                onChange={this.setCustomerContactPhone}
                fullWidth
                errorText={this.state.customerContactPhoneError}
              />
            </NitroGrid>

            <NitroGrid grid={2}>
              <NitroDatePicker
                value={deliveryDate}
                placeholder="Delivery date"
                onChange={this.setDeliveryDate}
                minDate={new Date()}
              />
            </NitroGrid>
          </NitroGrids>
        </NitroPanel>

        <Terms
          vehicle={selectedVehicle}
          estimatedCost={estimatedCost}
          disabled={!this.canSubmit() || this.props.updatingQuote}
          actionHandler={this.nextHandler}
          updatingQuote={this.props.updatingQuote}
          term={selectedTerms.Term}
          distance={selectedTerms.Distance}
        />
      </div>
    );
  }
}

DeliveryDetails.propTypes = {
  actions: PropTypes.object,
  quoteId: PropTypes.string,
  deliveryDetails: PropTypes.object,
  setDeliveryDetailsAddress: PropTypes.func,
  updatingQuote: PropTypes.bool,
  leaseDetails: PropTypes.object,
  selectColour: PropTypes.object,
  exteriorColour: PropTypes.array,
  selectedExtras: PropTypes.array,
  selectedVehicle: PropTypes.object,
  vehicles: PropTypes.object,
  selectedTerms: PropTypes.object,
  estimatedCost: PropTypes.number
};

//Pull in the React Router context so router is available on this.context.router.
DeliveryDetails.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  // extract the relevent parts of the state you need for this view
  const { create } = state.corporateQuote;
  return {
    selectedVehicle: create.selectedVehicle,
    estimatedCost: create.estimatedCost,
    quoteId: state.corporateQuote.create.quoteId,
    questions: create.questions,
    fetchingQuestions: create.fetchingQuestions,
    vehicles: create.vehicles,
    fetchingVehicles: create.fetchingVehicles,
    options: create.options,
    selectedExtras: create.selectedExtras,
    fetchingOptions: create.fetchingOptions,
    exteriorColour: create.selectedVehicle.ExteriorColour,
    selectedTerms: create.selectedTerms,
    selectColour: create.selectedColour,
    registerAddresses: create.registerAddresses,
    LeaseDetailsCache: create.leaseDetails,
    leaseDetails: create.leaseDetails
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetails);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/DeliveryDetails.js